import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const FolderGlyph = /*#__PURE__*/createElement("g", {
  id: "folder",
  fill: "none",
  style: {
    transform: 'scale(2.5)' // FIXME handle viewbox correctly after icons refactor, see "Folder.tsx" in etui-icons
  }
}, /*#__PURE__*/createElement("path", {
  d: "M5.28146 9.60059L5.28035 24.6503C5.28031 25.2449 5.7623 25.7269 6.35688 25.7269H25.6491C26.2436 25.7269 26.7256 25.2449 26.7256 24.6504V10.3702",
  stroke: "currentColor"
}), /*#__PURE__*/createElement("path", {
  d: "M5.27441 23.5417L5.27596 7.29636C5.27596 6.73321 5.73672 6.27246 6.29986 6.27246H12.2743C12.8374 6.27246 13.5183 6.6769 13.7896 7.17349L14.4398 8.36633C14.7111 8.86292 15.392 9.26735 15.9552 9.26735H25.7027C26.2658 9.26735 26.7266 9.7281 26.7266 10.2912V12.6411",
  stroke: "currentColor",
  strokeLinejoin: "round"
}));
const Folder = createSvg({
  name: 'folder',
  viewBox: '0 0 84 84',
  path: FolderGlyph
});

export default Folder;
export { FolderGlyph };
